import { render, staticRenderFns } from "./customerPayRecord.vue?vue&type=template&id=6002d5a2&"
import script from "./customerPayRecord.vue?vue&type=script&lang=js&"
export * from "./customerPayRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports